import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApprovalTerm = any // will be updated in subsequent PR

export default async function getApprovalTerms(
    applicationUuid: string,
    abortController: AbortController,
) {
    try {
        if (!applicationUuid) {
            throw new Error('invalid UUID')
        }

        const { data } = await axios.get(
            // eslint-disable-next-line max-len
            `${config.API_BASE_URL}/api/v3/applications/${applicationUuid}/approval-terms/`,
            {
                signal: abortController.signal,
                withCredentials: true,
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get approval terms: ${axiosError.message}`,
            axiosError,
            { applicationUuid },
        )

        throw axiosError
    }
}
